/* eslint-disable no-unused-vars */
import Vue from 'vue';
import i18n from '@utils/localization';
import Axios from '@utils/axios';
import Auth from '@utils/auth';
import FA from '@utils/fa';
import Tooltip from '@utils/tooltip';
import CKEditor from '@utils/ckeditor';
import CountryFlag from '@utils/countryflags';
import Multiselect from '@utils/multiselect';
import BootstrapVue from '@utils/bootstrap';
import Moment from '@utils/moment';
import Validation from '@validation/validation';
import VueBarcodeScanner from '@utils/VueBarcodeScanner';
import IdleVue from 'idle-vue';
import locale from 'element-ui/lib/locale';
import lang from 'element-ui/lib/locale/lang/cs-CZ';
import { DatePicker } from 'element-ui';
import store from './state/store';
import router from './router/router';
import App from './App.vue';
import './registerServiceWorker';
import vuetify from './vuetify';
/* eslint-enable no-unused-vars */

locale.use(lang);

Vue.config.productionTip = true;

const eventsHub = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Vue.use(IdleVue, {
  eventEmiter: eventsHub,
  store,
  idleTime: process.env.VUE_APP_IDLE_TIME * 1000,
  startAtIdle: false
});

Vue.use(DatePicker);
